import { render } from "./drop.vue?vue&type=template&id=06fb44a0&scoped=true"
import script from "./drop.vue?vue&type=script&lang=js"
export * from "./drop.vue?vue&type=script&lang=js"

import "./drop.vue?vue&type=style&index=0&id=06fb44a0&lang=scss&scoped=true"

import exportComponent from "E:\\Gitlab\\02_各园区PC端\\happyHarbour\\ningbo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06fb44a0"]])

export default __exports__